import { render, staticRenderFns } from "./PlanosRestricao.vue?vue&type=template&id=44415943"
import script from "./PlanosRestricao.vue?vue&type=script&lang=js"
export * from "./PlanosRestricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports